import React, { Fragment, useCallback, useEffect, useState } from 'react'
import axios from 'axios';

import FreeTrial from './FreeTrial';
import PaidPlan from './PaidPlan';
import NoPlanPurchased from './NoPlanPurchased';
import MegaLoader from '../../components/MegaLoader ';
function DashPlans() {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const GET_USER = `${SERVER_URI}/user`;
  const [userDetails, setUserDetails] = useState(null)
  const [loading, setLoading] = useState(false);

  const fetchUserData = useCallback(async () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      const response = await axios.get(GET_USER, config, { withCredentials: true, });
      setUserDetails(response.data.user)
    } catch (error) {
      console.log("error response", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUserData();
    // eslint-disable-next-line
  }, []);

  if (loading || userDetails === null) {
    // Show loader while data is being fetched or if userDetails is not yet set
    return <MegaLoader loading={loading} />;
  }

  return (
    <Fragment  >
      {userDetails?.paymentDetails?.paymentId === "free_trial" ?
        <FreeTrial userDetails={userDetails && userDetails} /> :
        !userDetails?.paymentDetails?.paymentId ? <NoPlanPurchased /> : <PaidPlan userDetails={userDetails && userDetails} />
      }
      {/* <FreeTrial /> */}
      {/* <PaidPlan /> */}

    </Fragment>
  )
}

export default DashPlans
